import { render, staticRenderFns } from "./register-entrance.vue?vue&type=template&id=1c755ea0&scoped=true&"
import script from "./register-entrance.vue?vue&type=script&lang=js&"
export * from "./register-entrance.vue?vue&type=script&lang=js&"
import style0 from "./register-entrance.vue?vue&type=style&index=0&id=1c755ea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c755ea0",
  null
  
)

export default component.exports